import { ApplicationRef, Inject, Injectable, LOCALE_ID, inject, DOCUMENT } from "@angular/core";
import { IpLocationService } from "./IpLocation.service";
import { TranslateService } from "@ngx-translate/core";
import { CurrencyPipe, registerLocaleData } from "@angular/common";
import localeEn from '@angular/common/locales/en';
import localeBR from '@angular/common/locales/br';
import localePTPT from '@angular/common/locales/pt-PT';
import { TranslocoLocaleService } from "@jsverse/transloco-locale";
import { TranslocoService } from "@jsverse/transloco";

@Injectable()
export class LanguageService {
    @Inject(LOCALE_ID) public localeId: string = 'pt-BR';
    private translocoService = inject(TranslocoService);
    private translocoLocaleService = inject(TranslocoLocaleService);
    private document = inject(DOCUMENT);
    private ipLocationService = inject(IpLocationService);
    private translate = inject(TranslateService);
    private applicationRef!: ApplicationRef;
    
    defaultDateFormat:string = 'MMM/dd/y';
       
    getLanguage(): string | null{
        return localStorage.getItem("language");        
    }

    getDateFormat(): string {
        return localStorage.getItem("dateFormat") ?? this.defaultDateFormat;
    }

    setLanguage(): void {
        const language = localStorage.getItem("language") === 'en' ? 'en-US' : localStorage.getItem("language");

        if (language) {
            this.translate.setDefaultLang(language);
            this.translate.use(language);
                            
            this.translocoLocaleService.setLocale(language);
            this.translocoService.setActiveLang(language);
            localStorage.setItem("dateFormat", this.buildDateFormat(language) );
            
        } else {
            this.ipLocationService.getUserCountry().subscribe(
                (data) => {
                    let language = data.country.toUpperCase();
                    switch (language) {
                        case 'pt-PT':
                        case 'PT':
                            language = 'pt-PT';
                            break;
                        case 'pt-BR':
                            language = 'pt-BR';
                            break;
                        default:
                            language = 'en';
                    }
                    localStorage.setItem("language", language );
                    localStorage.setItem("dateFormat", this.buildDateFormat(language) );
                    this.translate.setDefaultLang(data.country);
                    this.translate.use(language);
                    this.localeId = language;
                    this.translocoService.setActiveLang(language);
                    this.translocoLocaleService.setLocale(language);
                    return data.country;
                },
                (error) => {
                    localStorage.setItem("language", 'en');
                    localStorage.setItem("dateFormat", this.defaultDateFormat);
                    return 'en';
                }
            ); 
        }
    }    

    private buildDateFormat(language: string):string {
        if (language === 'PT' || language === 'pt-BR'  || language === 'pt-PT') {
            return 'dd/MM/y';
        }
        else {
            return this.defaultDateFormat;
        }
    }
}
